<template>
  <div class="mobile-phone">
    <router-link to="/navigate">
      <div class="return-arrow">
        <i class="el-icon-arrow-left" />
      </div>
    </router-link>
    <baidu-map class="baidu-map" :center="center" :zoom="zoom" @ready="handler" @click="closeSearchComplete">
      <bm-control>
        <el-row :gutter="12" class="baidu-map-control__row">
          <el-col :span="18">
            <el-col :span="10">
              <el-form class="margin-top">
                <el-form-item>
                  <el-select v-model="cityCode" placeholder="选择城市" clearable="clearable" autocomplete="off">
                    <el-option v-for="item in cityOptions" :key="item.value" :label="item.text" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form class="margin-top">
                <el-form-item>
                  <el-select v-model="type" placeholder="选择服务类型" clearable="clearable" autocomplete="off">
                    <el-option v-for="item in typeOptions" :key="item.index" :label="item.text" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
        </el-row>
      </bm-control>
      <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :offset="{width: 0, height: 0}" />
      <bm-boundary :name="mapBoundary" :stroke-weight="3" fill-color="" stroke-color="blue" />
      <bm-view :class="{ 'bm-view-full': !showNavigation, 'bm-view-half': showNavigation }" :center="center"
               :zoom="zoom"
      />
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
      <bm-marker :position="myLocation">
        <bm-label content="我的位置" :label-style="{color: 'red', fontSize: '16px'}" :offset="{width: -25, height: 30}"
                  :z-index="2"
        />
      </bm-marker>
      <bm-marker v-for="(item, index) in markerPoints"
                 :key="index"
                 :position="{ lng: item.lng, lat: item.lat}"
                 @click="onMarkerClick(index)"
                 @close="closeMarkerClick(index)"
      />
      <bm-transit v-if="showNavigation && showBusNavigation" :start="start" :end="end" :auto-viewport="true"
                  @searchcomplete="handleBusRouteSearchComplete"
      />
      <bm-walking v-if="showNavigation && showWalkingNavigation" :start="start" :end="end" :auto-viewport="true"
                  @searchcomplete="handleWalkingSearchComplete"
      />
      <bm-control>
        <el-dialog :visible.sync="mapMessageDialogVisible"
                   @close="closeMapMessageDialogVisible"
                   custom-class="bm-control__dialog"
                   width="100%"
                   :modal="false"
                   :append-to-body="true"
        >
          <div class="bm-control-dialog__map-message">
            <div class="title-wrapper">
              <h4 class="facility-name">{{ currentPosition.facilityName }}</h4>
              <div class="business-status-box"
                   :class="{ 'open': currentPosition.isBusinessHours , 'closed': !currentPosition.isBusinessHours }"
              >
                {{ currentPosition.isBusinessHours ? '营业中' : '休息中' }}
              </div>
              <i v-if="currentPosition.title && currentPosition.content" class="el-icon-document facility-speaker"
                 @click="showFacilityNotice(currentPosition)"
              />
            </div>
            <p class="facility-address" @click="handleCopyAddressClick(currentPosition.facilityAddress)"><i
              class="el-icon-location-outline"
            />{{ currentPosition.facilityAddress }}<span class="icon-color">复制</span>
            </p>
            <p class="facility-text">{{ currentPosition.dinstanceFmt }}</p>
            <p class="facility-time"><i class="el-icon-time" />上午:{{ currentPosition.amTime }} 下午:{{ currentPosition.pmTime }}</p>
            <div class="facility-service">
              <div class="service" v-if="currentPosition.serviceType && currentPosition.serviceType.includes(1005001)">
                <div class="icon-div">
                  <img src="../assets/icon_per.png" class="icon-img">
                  <span>个人详版查询</span>
                </div>
              </div>
              <div class="service" v-if="currentPosition.serviceType && currentPosition.serviceType.includes(1005002)">
                <div class="icon-div">
                  <img src="../assets/icon_smart.png" class="icon-img">
                  <span>个人简版查询</span>
                </div>
              </div>
              <div class="service" v-if="currentPosition.serviceType && currentPosition.serviceType.includes(1005003)">
                <div class="icon-div">
                  <img src="../assets/icon_per_hk.png" class="icon-img">
                  <span>个人港澳台回乡证查询</span>
                </div>
              </div>
              <div class="service" v-if="currentPosition.serviceType && currentPosition.serviceType.includes(1005004)">
                <div class="icon-div">
                  <img src="../assets/icon_ent.png" class="icon-img">
                  <span>企业电子营业执照授权查询</span>
                </div>
              </div>
              <div class="service" v-if="currentPosition.serviceType && currentPosition.serviceType.includes(1005005)">
                <div class="icon-div">
                  <img src="../assets/per_statement.png" class="icon-img">
                  <span>人工柜台服务</span>
                </div>
              </div>
            </div>
            <div v-if="!miniprogram" class="button-div">
              <el-button size="mini" @click="showBusNavigationButton(currentPosition)">公交去这里</el-button>
              <el-button size="mini" @click="showWalkingNavigationButton(currentPosition)">步行去这里</el-button>
            </div>
            <div v-else class="button-div">
              <el-button size="mini" @click="openLocation(currentPosition)">导航去这里</el-button>
            </div>
          </div>
        </el-dialog>
      </bm-control>
    </baidu-map>
    <el-dialog
      title="通知及公告"
      :visible.sync="isNoticeDialogVisible"
      @close="isNoticeDialogVisible = false"
      width="90%"
    >
      <div class="dialog-content">
        <h4 class="notice-title" v-html="currentFacilityNotice.title || ''" />
        <div v-html="currentFacilityNotice.content || ''" />
      </div>
      <div class="divider" />
      <span slot="footer">
        <el-button class="confirm-button" @click="isNoticeDialogVisible = false" size="small">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import axios from 'axios'
import wxUtil from "@/utils/WxUtil";

export default {
  name: 'Map',
  data() {
    return {
      miniprogram: window.miniprogram,
      mapMessageDialogVisible: false,
      currentPosition: {},
      timer: null,
      facilityList: [],
      location: '',
      markerPoints: [],
      center: '兰州市',
      mapBoundary: '甘肃省',
      zoom: 15,
      start: '',
      end: '',
      myLocation: {lng: null, lat: null},
      showNavigation: false,
      showBusNavigation: false,
      showWalkingNavigation: false,
      selectedFacility: null,
      isNoticeDialogVisible: false,
      currentFacilityNotice: {
        title: '',
        content: ''
      },
      cityCode: '',
      type: null,
      isChosen: 'N',
      cityOptions: [
        {value: '620100', text: '兰州市'},
        {value: '620200', text: '嘉峪关市'},
        {value: '620300', text: '金昌市'},
        {value: '620400', text: '白银市'},
        {value: '620500', text: '天水市'},
        {value: '620600', text: '武威市'},
        {value: '620700', text: '张掖市'},
        {value: '620800', text: '平凉市'},
        {value: '620900', text: '酒泉市'},
        {value: '621000', text: '庆阳市'},
        {value: '621100', text: '定西市'},
        {value: '621200', text: '陇南市'},
        {value: '622900', text: '临夏回族自治州'},
        {value: '623000', text: '甘南藏族自治州'}
      ],
      typeOptions: [
        {index: 0, value: 1005001, text: '个人详版查询'},
        {index: 1, value: 1005002, text: '个人简版查询'},
        {index: 2, value: 1005003, text: '个人港澳台回乡证查询'},
        {index: 3, value: 1005004, text: '企业电子营业执照授权查询'},
        {index: 4, value: 1005005, text: '人工柜台服务'}
      ]
    }
  },
  watch: {
    type(newValue) {
      this.isChosen = 'Y';
      this.type = newValue
      this.getListData()
    },
    cityCode(newValue) {
      this.isChosen = 'Y';
      this.cityCode = newValue;
      const city = this.cityOptions.find(Item => {
        return Item.value === newValue
      });
      this.center = city ? city.text : this.center;
      this.getListData()
    },
    facilityList: {
      handler(val) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        } else {
          this.timer = setTimeout(() => {
            this.$nextTick(() => {
              this.loadMarkerPoints(val);
              this.timer = null;
            });
          }, 300);
        }
      },
      immediate: false,
    }
  },
  mounted() {
    this.facilityList = this.$route.params.facilityList
    this.location = this.$route.params.location
    if (this.location) {
      this.myLocation.lng = this.location.split(',')[0]
      this.myLocation.lat = this.location.split(',')[1]
    }
    if (this.$route.params.currentBusinessType){
      this.type = this.$route.params.currentBusinessType;
    }

    if (this.$route.params.currentCityCode){
      this.cityCode = this.$route.params.currentCityCode;
    }
    if (this.$route.params.center) {
      this.center = this.$route.params.center
    }
  },
  methods: {
    openMapMessageDialogVisible() {
      this.mapMessageDialogVisible = true;
    },
    closeMapMessageDialogVisible() {
      this.mapMessageDialogVisible = false;
    },
    loadMarkerPoints(facilityList) {
      this.markerPoints = [];

      if (!facilityList || facilityList.length === 0) {
        return false;
      }

      const chunkSize = 5;
      let chunkIndex = 0;

      const renderNextChunk = () => {
        if (chunkIndex >= facilityList.length) {
          return false;
        }
        const chunkData = facilityList.slice(chunkIndex, chunkIndex + chunkSize);
        for (const i in chunkData) {
          const markerPoint = {id: null, lng: null, lat: null, facilityName: null, facilityAddress: null, show: false}
          let _data = chunkData[i];
          markerPoint.id = _data.id
          markerPoint.lng = _data.longitude.split(',')[0]
          markerPoint.lat = _data.longitude.split(',')[1]
          markerPoint.facilityName = _data.facilityName
          markerPoint.facilityAddress = _data.facilityAddress
          markerPoint.amTime = _data.amTime
          markerPoint.pmTime = _data.pmTime
          markerPoint.title = _data.title
          markerPoint.content = _data.content
          markerPoint.isBusinessHours = _data.isBusinessHours
          markerPoint.hasEnterQuery = _data.hasEnterQuery
          markerPoint.hasMulitpleId = _data.hasMulitpleId
          markerPoint.hasSelfQuery = _data.hasSelfQuery
          markerPoint.hasSmartMachine = _data.hasSmartMachine
          markerPoint.dinstanceFmt = _data.dinstanceFmt
          markerPoint.serviceType = _data.serviceType
          this.markerPoints.push((markerPoint))
        }
        chunkIndex = chunkIndex + chunkSize;
        requestAnimationFrame(renderNextChunk);
      }

      requestAnimationFrame(renderNextChunk);
    },
    handler({BMap, map}) {
      // this.lng = 103.848068
      // this.lat = 36.052349
      this.zoom = 15
      if (this.facilityList && this.facilityList.length  === 1){
        // 点击导航过来的
        const item = this.facilityList[0];
        if (item.distance){
          item.lng = item.longitude.split(',')[0]
          item.lat = item.longitude.split(',')[1]
          if (item.distance >= 1000){
            // 公交
            this.showBusNavigationButton(item)
          } else {
            // 步行
            this.showWalkingNavigationButton(item)
          }
        }
      }
      this.loadMarkerPoints(this.facilityList);
    },
    handleCopyAddressClick(address) {
      const tempElement = document.createElement('button')
      tempElement.setAttribute('data-clipboard-text', address)
      // 将临时元素添加到文档中
      this.$el.appendChild(tempElement)
      // 初始化 ClipboardJS
      const clipboard = new ClipboardJS(tempElement)
      // 触发点击事件，复制文本到剪贴板
      tempElement.click()
      // 在完成后销毁 ClipboardJS 实例和临时元素
      clipboard.destroy()
      this.$el.removeChild(tempElement)
      this.$alert('成功复制地址', '甘肃征信服务')
    },
    onMarkerClick(index) {
      this.$set(this.markerPoints, index, {...this.markerPoints[index], show: true})
      this.currentPosition = this.markerPoints[index];
      this.openMapMessageDialogVisible();
    },
    closeMarkerClick(index) {
      this.$set(this.markerPoints, index, {...this.markerPoints[index], show: false});
      this.currentPosition = {};
    },
    showBusNavigationButton(item) {
      this.closeMapMessageDialogVisible();
      this.showNavigation = true
      this.showBusNavigation = true
      this.showWalkingNavigation = false
      this.selectedFacility = item
      const locationArray = this.location.split(',')
      this.start = {lng: parseFloat(locationArray[0]), lat: parseFloat(locationArray[1])}
      this.end = {lng: parseFloat(item.lng), lat: parseFloat(item.lat)}
    },
    showWalkingNavigationButton(item) {
      this.closeMapMessageDialogVisible();
      this.showNavigation = true
      this.showBusNavigation = false
      this.showWalkingNavigation = true
      this.selectedFacility = item
      const locationArray = this.location.split(',')
      this.start = {lng: parseFloat(locationArray[0]), lat: parseFloat(locationArray[1])}
      this.end = {lng: parseFloat(item.lng), lat: parseFloat(item.lat)}
    },
    openLocation(item) {
      wxUtil.openLocation(item.lat, item.lng, item.facilityName, item.facilityAddress, '', '');
    },
    handleBusRouteSearchComplete(result) {
      if (result.getPlan(0) === undefined) {
        this.showNavigation = false
        this.$alert('不支持此种出行方式，请选择其他方式', '甘肃征信服务')
      }
    },
    handleWalkingSearchComplete(result) {
      if (result.getPlan(0) === undefined) {
        this.showNavigation = false
        this.$alert('未找到步行路线，请选择其他方式', '甘肃征信服务')
      }
    },
    showFacilityNotice(facility) {
      this.currentFacilityNotice.title = facility.title
      this.currentFacilityNotice.content = facility.content
      this.isNoticeDialogVisible = true
    },
    closeSearchComplete() {
      this.showNavigation = false
      this.showBusNavigation = false
      this.showWalkingNavigation = false
    },
    getListData() {
      axios.post(this.$config.baseUrl + '/appointment-web/facilityController/getFacilityList', {
        cityCode: this.cityCode,
        type: this.type,
        location: this.location,
        isChosen: this.isChosen
      }, {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          if (response.data && response.data.facilityList) {
            this.facilityList = response.data.facilityList;
          } else {
            this.facilityList = [];
          }
        })
        .catch(error => {
          console.log('请求错误:', error)
        })
    },
  }
}
</script>

<style scoped>
.mobile-phone {
  background-color: #f1f1f1;
  height: 100vh;
  margin: 0;
}

.baidu-map {
  width: 100%;
  height: 100%;
}

.bm-view-full {
  width: 100%;
  height: 100%;
}

.bm-view-half {
  width: 100%;
  height: 50%;
}

.facility-address {
  margin: 2% 0;
  color: #999;
  font-size: 13px;
}

.facility-time {
  margin: 0;
  padding-bottom: 5px;
  font-size: 12px;
  color: #a3a3a3;
}

::v-deep .bm-control__dialog .el-dialog__header{
  border-bottom: none;
  margin: 0;
  padding: 2% 0;
}

::v-deep .bm-control__dialog{
  margin-top: 0;
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  margin-bottom: 0 !important;
  transform: none !important;
  border-radius: 8px 8px 0 0;
  z-index: 9999;
}

::v-deep .bm-control__dialog .el-dialog__body {
  padding: 0 !important;
}

.bm-control-dialog__map-message{
  padding: 2%;
}

::v-deep .anchorBL {
  display: none !important;
}

.title-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  font-size: 16px;
}

.facility-name {
  margin: 0;
  font-weight: 400;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.facility-speaker {
  font-size: 16px;
  color: #b22d32;
  cursor: pointer;
  margin-left: 5px;
  align-self: center;
}

.facility-text {
  color: #b7b7b7;
  margin: 2% 0;
  font-size: 12px;
}

.margin-top {
  margin-top: 10px;
}

.baidu-map-control__row {
  display: flex;
  justify-content: space-between;
}

.notice-title {
  text-align: center;
}

::v-deep .el-dialog__body {
  padding: 0 20px 10px 20px !important;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #b22d32;
  margin: 0 20px;
  padding: 20px 0 10px 0;
}

.dialog-content {
  height: 480px;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

.confirm-button {
  color: #b22d32;
}

.icon-color {
  margin-left: .3rem;
  color: #2696e8;
}

.business-status-box {
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 14px;
  margin-left: 5px;
  white-space: nowrap;
}

.open {
  background-color: #2696e8;
  color: white;
}

.closed {
  background-color: #e1e1e1;
  color: #888888;
}

.facility-service {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
}

.service {
  padding: 3px 0;
  margin-right: 2px;
  font-size: 12px;
}

.icon-img {
  max-height: 15px;
  max-width: 15px;
}

.icon-div {
  color: #2696e8;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-div {
  padding: 20px 0;
  display: flex;
  text-align: center;
}

.return-arrow {
  position: absolute;
  top: 17px;
  left: 20px;
  cursor: pointer;
  font-size: 20px;
  color: #888888;
  z-index: 99;
  width: 8%;
  text-align: center;
}
</style>
